import { t } from 'i18next';

import env from 'configs/env';

export const languages = [
  {
    value: 'nl',
    label: 'Dutch',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'ja',
    label: 'Japanese',
  },
];

export const genders = [
  {
    value: 'MALE',
    label: t('male'),
  },
  {
    value: 'FEMALE',
    label: t('female'),
  },
  {
    value: 'UNDISCLOSED',
    label: t('undisclosed'),
  },
];

export const plusOneCountries = ['US', 'CA', 'PR', 'DO'];

export const countryCode = [
  { name: 'Ascension Island', dialCode: '+247', code: 'AC' },
  { name: 'Andorra', dialCode: '+376', code: 'AD' },
  { name: 'United Arab Emirates', dialCode: '+971', code: 'AE' },
  { name: 'Afghanistan', dialCode: '+93', code: 'AF' },
  { name: 'Antigua and Barbuda', dialCode: '+1268', code: 'AG' },
  { name: 'Anguilla', dialCode: '+1264', code: 'AI' },
  { name: 'Albania', dialCode: '+355', code: 'AL' },
  { name: 'Armenia', dialCode: '+374', code: 'AM' },
  { name: 'Angola', dialCode: '+244', code: 'AO' },
  { name: 'Antarctica', dialCode: '+672', code: 'AQ' },
  { name: 'Argentina', dialCode: '+54', code: 'AR' },
  { name: 'American Samoa', dialCode: '+1684', code: 'AS' },
  { name: 'Austria', dialCode: '+43', code: 'AT' },
  { name: 'Australia', dialCode: '+61', code: 'AU' },
  { name: 'Aruba', dialCode: '+297', code: 'AW' },
  { name: 'Aland Islands', dialCode: '+358', code: 'AX' },
  { name: 'Azerbaijan', dialCode: '+994', code: 'AZ' },
  { name: 'Bosnia and Herzegovina', dialCode: '+387', code: 'BA' },
  { name: 'Barbados', dialCode: '+1246', code: 'BB' },
  { name: 'Bangladesh', dialCode: '+880', code: 'BD' },
  { name: 'Belgium', dialCode: '+32', code: 'BE' },
  { name: 'Burkina Faso', dialCode: '+226', code: 'BF' },
  { name: 'Bulgaria', dialCode: '+359', code: 'BG' },
  { name: 'Bahrain', dialCode: '+973', code: 'BH' },
  { name: 'Burundi', dialCode: '+257', code: 'BI' },
  { name: 'Benin', dialCode: '+229', code: 'BJ' },
  { name: 'Saint Barthelemy', dialCode: '+590', code: 'BL' },
  { name: 'Bermuda', dialCode: '+1441', code: 'BM' },
  { name: 'Brunei Darussalam', dialCode: '+673', code: 'BN' },
  { name: 'Bolivia, Plurinational State of', dialCode: '+591', code: 'BO' },
  { name: 'Bonaire, Sint Eustatius and Saba', dialCode: '+599', code: 'BQ' },
  { name: 'Brazil', dialCode: '+55', code: 'BR' },
  { name: 'Bahamas', dialCode: '+1242', code: 'BS' },
  { name: 'Bhutan', dialCode: '+975', code: 'BT' },
  { name: 'Bouvet Island', dialCode: '+47', code: 'BV' },
  { name: 'Botswana', dialCode: '+267', code: 'BW' },
  { name: 'Belarus', dialCode: '+375', code: 'BY' },
  { name: 'Belize', dialCode: '+501', code: 'BZ' },
  { name: 'Canada', dialCode: '+1', code: 'CA' },
  { name: 'Cocos (Keeling) Islands', dialCode: '+61', code: 'CC' },
  { name: 'Congo, The Democratic Republic of the Congo', dialCode: '+243', code: 'CD' },
  { name: 'Central African Republic', dialCode: '+236', code: 'CF' },
  { name: 'Congo', dialCode: '+242', code: 'CG' },
  { name: 'Switzerland', dialCode: '+41', code: 'CH' },
  { name: "Cote d'Ivoire", dialCode: '+225', code: 'CI' },
  { name: 'Cook Islands', dialCode: '+682', code: 'CK' },
  { name: 'Chile', dialCode: '+56', code: 'CL' },
  { name: 'Cameroon', dialCode: '+237', code: 'CM' },
  { name: 'China', dialCode: '+86', code: 'CN' },
  { name: 'Colombia', dialCode: '+57', code: 'CO' },
  { name: 'Costa Rica', dialCode: '+506', code: 'CR' },
  { name: 'Cuba', dialCode: '+53', code: 'CU' },
  { name: 'Cape Verde', dialCode: '+238', code: 'CV' },
  { name: 'Curaçao', dialCode: '+599', code: 'CW' },
  { name: 'Christmas Island', dialCode: '+61', code: 'CX' },
  { name: 'Cyprus', dialCode: '+357', code: 'CY' },
  { name: 'Czech Republic', dialCode: '+420', code: 'CZ' },
  { name: 'Germany', dialCode: '+49', code: 'DE' },
  { name: 'Diego Garcia', dialCode: '+264', code: 'DG' },
  { name: 'Djibouti', dialCode: '+253', code: 'DJ' },
  { name: 'Denmark', dialCode: '+45', code: 'DK' },
  { name: 'Dominica', dialCode: '+1767', code: 'DM' },
  { name: 'Dominican Republic', dialCode: '+1', code: 'DO' },
  { name: 'Algeria', dialCode: '+213', code: 'DZ' },
  { name: 'Ecuador', dialCode: '+593', code: 'EC' },
  { name: 'Estonia', dialCode: '+372', code: 'EE' },
  { name: 'Egypt', dialCode: '+20', code: 'EG' },
  { name: 'Western Sahara', dialCode: '+212', code: 'EH' },
  { name: 'Eritrea', dialCode: '+291', code: 'ER' },
  { name: 'Spain', dialCode: '+34', code: 'ES' },
  { name: 'Ethiopia', dialCode: '+251', code: 'ET' },
  { name: 'Finland', dialCode: '+358', code: 'FI' },
  { name: 'Fiji', dialCode: '+679', code: 'FJ' },
  { name: 'Falkland Islands (Malvinas)', dialCode: '+500', code: 'FK' },
  { name: 'Micronesia, Federated States of Micronesia', dialCode: '+691', code: 'FM' },
  { name: 'Faroe Islands', dialCode: '+298', code: 'FO' },
  { name: 'France', dialCode: '+33', code: 'FR' },
  { name: 'Gabon', dialCode: '+241', code: 'GA' },
  { name: 'United Kingdom', dialCode: '+44', code: 'GB' },
  { name: 'Grenada', dialCode: '+1473', code: 'GD' },
  { name: 'Georgia', dialCode: '+995', code: 'GE' },
  { name: 'French Guiana', dialCode: '+594', code: 'GF' },
  { name: 'Guernsey', dialCode: '+44', code: 'GG' },
  { name: 'Ghana', dialCode: '+233', code: 'GH' },
  { name: 'Gibraltar', dialCode: '+350', code: 'GI' },
  { name: 'Greenland', dialCode: '+299', code: 'GL' },
  { name: 'Gambia', dialCode: '+220', code: 'GM' },
  { name: 'Guinea', dialCode: '+224', code: 'GN' },
  { name: 'Guadeloupe', dialCode: '+590', code: 'GP' },
  { name: 'Equatorial Guinea', dialCode: '+240', code: 'GQ' },
  { name: 'Greece', dialCode: '+30', code: 'GR' },
  { name: 'South Georgia and the South Sandwich Islands', dialCode: '+500', code: 'GS' },
  { name: 'Guatemala', dialCode: '+502', code: 'GT' },
  { name: 'Guam', dialCode: '+1671', code: 'GU' },
  { name: 'Guinea-Bissau', dialCode: '+245', code: 'GW' },
  { name: 'Guyana', dialCode: '+595', code: 'GY' },
  { name: 'Hong Kong', dialCode: '+852', code: 'HK' },
  { name: 'Heard Island and McDonald Islands', dialCode: '+672', code: 'HM' },
  { name: 'Honduras', dialCode: '+504', code: 'HN' },
  { name: 'Croatia', dialCode: '+385', code: 'HR' },
  { name: 'Haiti', dialCode: '+509', code: 'HT' },
  { name: 'Hungary', dialCode: '+36', code: 'HU' },
  { name: 'Canary Islands', dialCode: '+34', code: 'IC' },
  { name: 'Indonesia', dialCode: '+62', code: 'ID' },
  { name: 'Ireland', dialCode: '+353', code: 'IE' },
  { name: 'Israel', dialCode: '+972', code: 'IL' },
  { name: 'Isle of Man', dialCode: '+44', code: 'IM' },
  { name: 'India', dialCode: '+91', code: 'IN' },
  { name: 'British Indian Ocean Territory', dialCode: '+246', code: 'IO' },
  { name: 'Iraq', dialCode: '+964', code: 'IQ' },
  { name: 'Iran, Islamic Republic of Persian Gulf', dialCode: '+98', code: 'IR' },
  { name: 'Iceland', dialCode: '+354', code: 'IS' },
  { name: 'Italy', dialCode: '+39', code: 'IT' },
  { name: 'Jersey', dialCode: '+44', code: 'JE' },
  { name: 'Jamaica', dialCode: '+1876', code: 'JM' },
  { name: 'Jordan', dialCode: '+962', code: 'JO' },
  { name: 'Japan', dialCode: '+81', code: 'JP' },
  { name: 'Kenya', dialCode: '+254', code: 'KE' },
  { name: 'Kyrgyzstan', dialCode: '+996', code: 'KG' },
  { name: 'Cambodia', dialCode: '+855', code: 'KH' },
  { name: 'Kiribati', dialCode: '+686', code: 'KI' },
  { name: 'Comoros', dialCode: '+269', code: 'KM' },
  { name: 'Saint Kitts and Nevis', dialCode: '+1869', code: 'KN' },
  { name: "Korea, Democratic People's Republic of Korea", dialCode: '+850', code: 'KP' },
  { name: 'Korea, Republic of South Korea', dialCode: '+82', code: 'KR' },
  { name: 'Kuwait', dialCode: '+965', code: 'KW' },
  { name: 'Cayman Islands', dialCode: '+ 345', code: 'KY' },
  { name: 'Kazakhstan', dialCode: '+77', code: 'KZ' },
  { name: 'Laos', dialCode: '+856', code: 'LA' },
  { name: 'Lebanon', dialCode: '+961', code: 'LB' },
  { name: 'Saint Lucia', dialCode: '+1758', code: 'LC' },
  { name: 'Liechtenstein', dialCode: '+423', code: 'LI' },
  { name: 'Sri Lanka', dialCode: '+94', code: 'LK' },
  { name: 'Liberia', dialCode: '+231', code: 'LR' },
  { name: 'Lesotho', dialCode: '+266', code: 'LS' },
  { name: 'Lithuania', dialCode: '+370', code: 'LT' },
  { name: 'Luxembourg', dialCode: '+352', code: 'LU' },
  { name: 'Latvia', dialCode: '+371', code: 'LV' },
  { name: 'Libyan Arab Jamahiriya', dialCode: '+218', code: 'LY' },
  { name: 'Morocco', dialCode: '+212', code: 'MA' },
  { name: 'Monaco', dialCode: '+377', code: 'MC' },
  { name: 'Moldova', dialCode: '+373', code: 'MD' },
  { name: 'Montenegro', dialCode: '+382', code: 'ME' },
  { name: 'Saint Martin', dialCode: '+590', code: 'MF' },
  { name: 'Madagascar', dialCode: '+261', code: 'MG' },
  { name: 'Marshall Islands', dialCode: '+692', code: 'MH' },
  { name: 'Macedonia', dialCode: '+389', code: 'MK' },
  { name: 'Mali', dialCode: '+223', code: 'ML' },
  { name: 'Myanmar', dialCode: '+95', code: 'MM' },
  { name: 'Mongolia', dialCode: '+976', code: 'MN' },
  { name: 'Macao', dialCode: '+853', code: 'MO' },
  { name: 'Northern Mariana Islands', dialCode: '+1670', code: 'MP' },
  { name: 'Martinique', dialCode: '+596', code: 'MQ' },
  { name: 'Mauritania', dialCode: '+222', code: 'MR' },
  { name: 'Montserrat', dialCode: '+1664', code: 'MS' },
  { name: 'Malta', dialCode: '+356', code: 'MT' },
  { name: 'Mauritius', dialCode: '+230', code: 'MU' },
  { name: 'Maldives', dialCode: '+960', code: 'MV' },
  { name: 'Malawi', dialCode: '+265', code: 'MW' },
  { name: 'Mexico', dialCode: '+52', code: 'MX' },
  { name: 'Malaysia', dialCode: '+60', code: 'MY' },
  { name: 'Mozambique', dialCode: '+258', code: 'MZ' },
  { name: 'Namibia', dialCode: '+264', code: 'NA' },
  { name: 'New Caledonia', dialCode: '+687', code: 'NC' },
  { name: 'Niger', dialCode: '+227', code: 'NE' },
  { name: 'Norfolk Island', dialCode: '+672', code: 'NF' },
  { name: 'Nigeria', dialCode: '+234', code: 'NG' },
  { name: 'Nicaragua', dialCode: '+505', code: 'NI' },
  { name: 'Netherlands', dialCode: '+31', code: 'NL' },
  { name: 'Norway', dialCode: '+47', code: 'NO' },
  { name: 'Nepal', dialCode: '+977', code: 'NP' },
  { name: 'Nauru', dialCode: '+674', code: 'NR' },
  { name: 'Niue', dialCode: '+683', code: 'NU' },
  { name: 'New Zealand', dialCode: '+64', code: 'NZ' },
  { name: 'Oman', dialCode: '+968', code: 'OM' },
  { name: 'Panama', dialCode: '+507', code: 'PA' },
  { name: 'Peru', dialCode: '+51', code: 'PE' },
  { name: 'French Polynesia', dialCode: '+689', code: 'PF' },
  { name: 'Papua New Guinea', dialCode: '+675', code: 'PG' },
  { name: 'Philippines', dialCode: '+63', code: 'PH' },
  { name: 'Pakistan', dialCode: '+92', code: 'PK' },
  { name: 'Poland', dialCode: '+48', code: 'PL' },
  { name: 'Saint Pierre and Miquelon', dialCode: '+508', code: 'PM' },
  { name: 'Pitcairn', dialCode: '+872', code: 'PN' },
  { name: 'Puerto Rico', dialCode: '+1', code: 'PR' },
  { name: 'Palestinian Territory, Occupied', dialCode: '+970', code: 'PS' },
  { name: 'Portugal', dialCode: '+351', code: 'PT' },
  { name: 'Palau', dialCode: '+680', code: 'PW' },
  { name: 'Paraguay', dialCode: '+595', code: 'PY' },
  { name: 'Qatar', dialCode: '+974', code: 'QA' },
  { name: 'Reunion', dialCode: '+262', code: 'RE' },
  { name: 'Romania', dialCode: '+40', code: 'RO' },
  { name: 'Serbia', dialCode: '+381', code: 'RS' },
  { name: 'Russia', dialCode: '+7', code: 'RU' },
  { name: 'Rwanda', dialCode: '+250', code: 'RW' },
  { name: 'Saudi Arabia', dialCode: '+966', code: 'SA' },
  { name: 'Solomon Islands', dialCode: '+677', code: 'SB' },
  { name: 'Seychelles', dialCode: '+248', code: 'SC' },
  { name: 'Sudan', dialCode: '+249', code: 'SD' },
  { name: 'Sweden', dialCode: '+46', code: 'SE' },
  { name: 'Singapore', dialCode: '+65', code: 'SG' },
  { name: 'Saint Helena, Ascension and Tristan Da Cunha', dialCode: '+290', code: 'SH' },
  { name: 'Slovenia', dialCode: '+386', code: 'SI' },
  { name: 'Svalbard and Jan Mayen', dialCode: '+47', code: 'SJ' },
  { name: 'Slovakia', dialCode: '+421', code: 'SK' },
  { name: 'Sierra Leone', dialCode: '+232', code: 'SL' },
  { name: 'San Marino', dialCode: '+378', code: 'SM' },
  { name: 'Senegal', dialCode: '+221', code: 'SN' },
  { name: 'Somalia', dialCode: '+252', code: 'SO' },
  { name: 'Suriname', dialCode: '+597', code: 'SR' },
  { name: 'South Sudan', dialCode: '+211', code: 'SS' },
  { name: 'Sao Tome and Principe', dialCode: '+239', code: 'ST' },
  { name: 'El Salvador', dialCode: '+503', code: 'SV' },
  { name: 'Sint Maarten', dialCode: '+721', code: 'SX' },
  { name: 'Syrian Arab Republic', dialCode: '+963', code: 'SY' },
  { name: 'Swaziland', dialCode: '+268', code: 'SZ' },
  { name: 'Turks and Caicos Islands', dialCode: '+1649', code: 'TC' },
  { name: 'Chad', dialCode: '+235', code: 'TD' },
  { name: 'French Southern Territories', dialCode: '+262', code: 'TF' },
  { name: 'Togo', dialCode: '+228', code: 'TG' },
  { name: 'Thailand', dialCode: '+66', code: 'TH' },
  { name: 'Tajikistan', dialCode: '+992', code: 'TJ' },
  { name: 'Tokelau', dialCode: '+690', code: 'TK' },
  { name: 'Timor-Leste', dialCode: '+670', code: 'TL' },
  { name: 'Turkmenistan', dialCode: '+993', code: 'TM' },
  { name: 'Tunisia', dialCode: '+216', code: 'TN' },
  { name: 'Tonga', dialCode: '+676', code: 'TO' },
  { name: 'Turkey', dialCode: '+90', code: 'TR' },
  { name: 'Trinidad and Tobago', dialCode: '+1868', code: 'TT' },
  { name: 'Tuvalu', dialCode: '+688', code: 'TV' },
  { name: 'Taiwan', dialCode: '+886', code: 'TW' },
  { name: 'Tanzania, United Republic of Tanzania', dialCode: '+255', code: 'TZ' },
  { name: 'Ukraine', dialCode: '+380', code: 'UA' },
  { name: 'Uganda', dialCode: '+256', code: 'UG' },
  { name: 'United States Minor Outlying Islands', dialCode: '+699', code: 'UM' },
  { name: 'United States', dialCode: '+1', code: 'US' },
  { name: 'Uruguay', dialCode: '+598', code: 'UY' },
  { name: 'Uzbekistan', dialCode: '+998', code: 'UZ' },
  { name: 'Holy See (Vatican City State)', dialCode: '+379', code: 'VA' },
  { name: 'Saint Vincent and the Grenadines', dialCode: '+1784', code: 'VC' },
  { name: 'Venezuela, Bolivarian Republic of Venezuela', dialCode: '+58', code: 'VE' },
  { name: 'Virgin Islands, British', dialCode: '+1284', code: 'VG' },
  { name: 'Virgin Islands, U.S.', dialCode: '+1340', code: 'VI' },
  { name: 'Vietnam', dialCode: '+84', code: 'VN' },
  { name: 'Vanuatu', dialCode: '+678', code: 'VU' },
  { name: 'Wallis and Futuna', dialCode: '+681', code: 'WF' },
  { name: 'Samoa', dialCode: '+685', code: 'WS' },
  { name: 'Kosovo', dialCode: '+383', code: 'XK' },
  { name: 'Yemen', dialCode: '+967', code: 'YE' },
  { name: 'Mayotte', dialCode: '+262', code: 'YT' },
  { name: 'South Africa', dialCode: '+27', code: 'ZA' },
  { name: 'Zambia', dialCode: '+260', code: 'ZM' },
  { name: 'Zimbabwe', dialCode: '+263', code: 'ZW' },
];

const codes = countryCode.map((el) => el.dialCode);
const uniqueCodes = new Set(codes);

export const extensions = Array.from(uniqueCodes).map((el) => {
  return { label: el, value: el };
});

export const countries = countryCode.map((el) => {
  return { label: el.name, value: el.code };
});

export const titles = [
  { value: 'mr', label: 'Mr.' },
  { value: 'dr', label: 'Dr.' },
  { value: 'ms', label: 'Ms.' },
  { value: 'mrs', label: 'Mrs.' },
  { value: 'prof', label: 'Prof.' },
];

export const roles = [
  { value: 'PHYSICIAN', label: t('consts.roles.physician') },
  { value: 'ADMIN', label: t('consts.roles.admin') },
  { value: 'DEVELOPER', label: t('consts.roles.developer') },
];

export const snippetCategories = [
  { label: t('consts.snippets.findings'), value: 'FINDINGS' },
  { label: t('consts.snippets.diagnosis'), value: 'DIAGNOSIS' },
  { label: t('consts.snippets.recommendations'), value: 'RECOMMENDATIONS' },
];

export const teststatuses = [
  { label: t('consts.status.new'), value: 'new' },
  { label: t('consts.status.progress'), value: 'in-progress' },
  { label: t('consts.status.complete'), value: 'completed' },
  { label: t('consts.status.interpreted'), value: 'interpreted' },
];

export const nameRegex = /^[\p{L}\p{M}\s'-]+$/u; // letters, marks (e.g., accents), whitespace, apostrophes, and hyphens

export const infoRegex = /^[\p{L}\p{M}\s0-9/,.%'@_\-<>=]*$/u; // Alphanumeric, spaces, hyphens, slashes, periods, apostrophes, %,@, >, <, =

export const alphaNumRegex = /^[\p{L}\p{M}\s0-9./-]+$/u; // allow letters, numbers, spaces, hyphens, slashes, and periods.

export const stateRegex = /^[\p{L}\p{M}\s'-]+$/u;

export const cityRegex = /^[\p{L}\p{M}\s0-9'-]+$/u; // Allows alphabetic characters, spaces, apostrophes, and hyphens

export const adrRegex = /^[\p{L}\p{M}\s0-9,#.-]+$/u; // string that contains letters, numbers, spaces, commas, hyphens, #, and periods (.)

export const phoneRegex = /^\+?\d{9,14}$/;

export const authRegex = /^[a-zA-Z0-9._@-]{3,50}$/;

export const emailRegex =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

// eslint-disable-next-line no-useless-escape
export const passwordRegex = /^[A-Za-z0-9!@#$%^&*()_+=\[\]{}|;:'",.<>?\/-]{3,50}$/;

export const whitespaceFeedback = t('consts.whitespace-rule');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const langDateMap: any = {
  default: 'DD/MM/YYYY',
  'en-US': 'MM/DD/YYYY',
  ja: 'YYYY/MM/DD',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const langDateTimeMap: any = {
  default: 'DD/MM/YYYY hh:mm A',
  'en-US': 'MM/DD/YYYY hh:mm A',
  ja: 'YYYY/MM/DD hh:mm A',
};

export const snippetsOrder = ['FINDINGS', 'DIAGNOSIS', 'RECOMMENDATIONS'];

export const hcpManual = 'https://d3gpgyvubd2nlh.cloudfront.net/hcp-manual.pdf';

export const nightowlFaqs = 'https://d3kaa542e466hj.cloudfront.net/NightOwl_FAQs.pdf';

export const termsOfUse = 'https://d10vztgu7nakz5.cloudfront.net/nightowl-portal/us/EN.html';

export const termsOfUsePdf =
  env.environment === 'prod'
    ? 'https://d10vztgu7nakz5.cloudfront.net/nightowl-portal/us/EN.pdf'
    : 'https://d3p97wgpbyerri.cloudfront.net/nightowl-portal/us/EN.pdf';

export const privacyNotice =
  'https://www.resmed.com/en-us/health-professionals/customer-privacy-notice/';

export const eventOptions = [{ value: 'report update', label: 'Report Update' }];

export const authType = [
  { value: 'Basic', label: 'Basic' },
  { value: 'Bearer', label: 'Bearer' },
];

export const reviewDataOption = [
  { key: '3', label: '3%' },
  { key: '4', label: '4%' },
];

export const supportEmail = 'nightowl@resmed.com';

export const hipaaResponse = 'Please accept the terms and conditions include HIPAA authorization';
export const localStorageConst = {
  banner: 'bannerVisible',
};
